/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PrtimesMediaOutlet,
    PrtimesMediaOutletFromJSON,
    PrtimesMediaOutletFromJSONTyped,
    PrtimesMediaOutletToJSON,
} from './PrtimesMediaOutlet';

/**
 * response of GET /prtimes_media_lists/{media_list_id}/selected_media_lists/logs/{log_id}
 * @export
 * @interface PrtimesMediaListsSelectedMediaListsLogGetResponse
 */
export interface PrtimesMediaListsSelectedMediaListsLogGetResponse {
    /**
     * メディアリスト名
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogGetResponse
     */
    mediaListName: string;
    /**
     * 送信者名
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogGetResponse
     */
    senderName: string;
    /**
     * 送信元のメールアドレス
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogGetResponse
     */
    fromEmail: string;
    /**
     * メディアリストの更新日
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogGetResponse
     */
    updatedAt: string;
    /**
     * メディアのリスト
     * @type {Array<PrtimesMediaOutlet>}
     * @memberof PrtimesMediaListsSelectedMediaListsLogGetResponse
     */
    mediaOutlets: Array<PrtimesMediaOutlet>;
}

export function PrtimesMediaListsSelectedMediaListsLogGetResponseFromJSON(json: any): PrtimesMediaListsSelectedMediaListsLogGetResponse {
    return PrtimesMediaListsSelectedMediaListsLogGetResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListsSelectedMediaListsLogGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsSelectedMediaListsLogGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListName': json['media_list_name'],
        'senderName': json['sender_name'],
        'fromEmail': json['from_email'],
        'updatedAt': json['updated_at'],
        'mediaOutlets': ((json['media_outlets'] as Array<any>).map(PrtimesMediaOutletFromJSON)),
    };
}

export function PrtimesMediaListsSelectedMediaListsLogGetResponseToJSON(value?: PrtimesMediaListsSelectedMediaListsLogGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_name': value.mediaListName,
        'sender_name': value.senderName,
        'from_email': value.fromEmail,
        'updated_at': value.updatedAt,
        'media_outlets': ((value.mediaOutlets as Array<any>).map(PrtimesMediaOutletToJSON)),
    };
}

